import React, { useState } from 'react';

import { get, isArray } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import MyButton from '@common/components/Button/MyButton';
import MyCheckbox from '@common/components/MyCheckbox/MyCheckbox';
import { INIT_TABLE_MODAL_STATE } from '@common/constants';

const TableModal = ({
  showModal,
  setShowModal,
  currentValue,
  changeSrcValue,
  documentJson,
}) => {
  const { t } = useTranslation();

  const [checkedField, setCheckedField] = useState(
    currentValue ? currentValue : undefined
  );

  const changeSelected = (data) => {
    let newValue = data.name === checkedField ? '' : data.name;
    setCheckedField(newValue);
  };

  const onOkClicked = () => {
    changeSrcValue(checkedField);
    setShowModal(INIT_TABLE_MODAL_STATE);
  };

  const getDocumentFields = (providedDocument = {}) => {
    const currentJsonStructure = showModal?.pathToThisElement
      ? get(providedDocument, showModal.pathToThisElement, {})
      : providedDocument;
    let objKeys = Object.keys(currentJsonStructure);
    return objKeys.map((propKey) => {
      if (isArray(currentJsonStructure[propKey])) {
        return (
          <Box key={propKey}>
            <MyCheckbox
              label={propKey}
              name={propKey}
              checked={checkedField === propKey}
              onChange={changeSelected}
            />
          </Box>
        );
      } else {
        return <div key={propKey} />;
      }
    });
  };

  return (
    <Dialog fullWidth maxWidth={'sm'} open={showModal?.show}>
      <DialogTitle>{t('modal_header')}</DialogTitle>
      <DialogContent>
        <Box>{getDocumentFields(documentJson)}</Box>
      </DialogContent>
      <DialogActions>
        <MyButton onClick={() => setShowModal(INIT_TABLE_MODAL_STATE)}>
          {t('cancel')}
        </MyButton>
        <MyButton onClick={onOkClicked}>{t('ok')}</MyButton>
      </DialogActions>
    </Dialog>
  );
};

export default TableModal;
